import React, { useEffect, useState } from 'react'
import DropdownComp from '../common/form-components/dropdown/DropdownComp'
import CenterService from '../../services/centers/center.service'
import { ControlLabel } from '../common/form-components/label/Label'

const CentersDropdown = ({ idLabel, required, value, onChange }) => {
  const [centers, setCenters] = useState([])

  useEffect(() => {
    getCenters()
  }, [])

  const getCenters = async () => {
    const resp = await CenterService.getAll({ sort: 'name' })
    if (resp) {
      setCenters(resp)
    }
  }

  return (
    <div className={`${idLabel ? 'flex-container' : undefined}`}>
      {idLabel && <ControlLabel id={idLabel} required={required} />}
      <div className={`${idLabel ? 'control-input' : undefined}`}>
        <DropdownComp
          value={value?._id || value}
          options={centers?.resp}
          name="center"
          optionLabel="basicData.name"
          optionValue="_id"
          onChange={onChange}
        />
      </div>
    </div>
  )
}
export default CentersDropdown
